import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en clases-page.tsx y se descarga aparte (code-split) — así visitar
// el home u otra página pública no baja el bundle de esta (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/clases",
  head: () => ({
    meta: seoMeta({
      title: "Clases de Calistenia en Santiago — Calistenia Progresiva",
      description: "Clases de calistenia grupales y personalizadas en Santiago. Horarios, ubicaciones y precios — agenda tu primera clase.",
      path: "/clases",
    }),
    links: [canonicalLink("/clases")],
  }),
  component: lazyRouteComponent(() => import("./clases-page"), "ClasesPage"),
});
